export default __webpack_public_path__ + "static/media/SELLOS_DISCOS_02.f7907f4c.png";